var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("iframe", {
    staticClass: "w-100 iframe-component",
    staticStyle: { border: "none" },
    attrs: { id: _vm.getIframeId, src: _vm.url },
    on: { load: _vm.onMessageLoad },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }